(function() {
  'use strict';

  function initNotifyMeToggle() {
    const notifyMeContainers = document.querySelectorAll('[data-notify-me-section]');

    notifyMeContainers.forEach(container => {
      const sectionId = container.dataset.notifyMeSection;
      const atcButton = document.querySelector(`#x-atc-button-${sectionId}`);
      const buyButtonsContainer = document.querySelector(`.x-block-buy-buttons`);
      const notifyMeForm = container;

      if (!atcButton || !buyButtonsContainer) {
        return;
      }

      function toggleForms() {
        const isAvailable = atcButton.dataset.available === 'true';
        const isDisabled = atcButton.hasAttribute('disabled');

        if (isAvailable && !isDisabled) {
          buyButtonsContainer.style.display = '';
          notifyMeForm.classList.add('hidden');
        } else {
          buyButtonsContainer.style.display = 'none';
          notifyMeForm.classList.remove('hidden');
        }
      }

      setTimeout(() => {
        toggleForms();
      }, 100);

      toggleForms();

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-available' || mutation.attributeName === 'disabled') {
            toggleForms();
          }
        });
      });

      observer.observe(atcButton, {
        attributes: true,
        attributeFilter: ['data-available', 'disabled']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNotifyMeToggle);
  } else {
    initNotifyMeToggle();
  }

  let initTimeout;
  const reinitOnChange = () => {
    clearTimeout(initTimeout);
    initTimeout = setTimeout(() => {
      initNotifyMeToggle();
    }, 500);
  };

  const bodyObserver = new MutationObserver(reinitOnChange);
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
